import React__default, { forwardRef, useRef } from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import Box from '../Box/Box.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';
import { useCenterY } from './hooks/useCenterY.js';

const StyledPositionalItemWrapper = styled(Box).withConfig({
  displayName: "PositionAwareItem__StyledPositionalItemWrapper",
  componentId: "sc-1lc2c8e-0"
})(["", ""], sx);
/**
 *
 * A component that wraps its children and updates the selected item in a VerticalPositionContext context using
 * the useCenterY hook.
 *
 */
const PositionAwareItem = /*#__PURE__*/forwardRef(({
  id = '',
  children,
  sx: sxProp,
  testId,
  onItemSelect
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const wrapperTestId = `${testId}-wrapper`;
  const {
    onSelectItem
  } = useCenterY();
  const handleClick = event => {
    onSelectItem(event.target, id);
    if (onItemSelect) onItemSelect();
  };
  return /*#__PURE__*/React__default.createElement(StyledPositionalItemWrapper, {
    onClick: handleClick,
    sx: sxProp,
    "data-testid": testId ? wrapperTestId : null,
    ref: innerRef
  }, children);
});
PositionAwareItem.displayName = 'PositionAwareItem';
var PositionAwareItem$1 = PositionAwareItem;

export { PositionAwareItem$1 as default };
